const AssistantAvatar = () => {
  return (
    <img
      src="/images/favicon/android-chrome-192x192.png"
      alt="Assistant"
      width={32}
      height={32}
      draggable={false}
      style={{
        display: "block",
        width: "32px",
        height: "32px",
        minWidth: "32px",
        maxWidth: "32px",
        objectFit: "contain",
        flex: "0 0 32px",
      }}
    />
  );
};

export default AssistantAvatar;
